// Page Data Grup
// --------------------------------------------------------

import React, { useEffect, useState } from "react";
import Title from "../../../components/Title";
import { styled } from "@mui/material/styles";
import Table from "../../../components/Table";
import Button from "../../../components/Button";
import Chart from "../../../components/Chart";
import ChartBar from "../../../components/ChartBar";
import moment from "moment";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getDasboardGroup,
  getDetailGrup,
  getRequestGrup,
  setActiveStep,
  setSelectGrup,
} from "../../../store/actions/dataGroup";

// Asset
import eye from "../../../assets/icon/Eye.svg";
import { ReactComponent as IconGroup } from "../../../assets/icon/icon_group.svg";
import iconCalendar from "../../../assets/icon/icon-calendar.png";
import { capFirstLetter, stringToColor } from "../../../utils/helpers";

const DataGroup = ({ setHistory }) => {
  const dispatch = useDispatch();

  const { dashboardGroup } = useSelector((state) => state.dataGroup);

  const [pieChart, setPieChart] = useState(initialPieChart);
  const [datasets, setDataSet] = useState([]);

  const dataHeader = [
    {
      title: "No",
      key: "group_id",
      width: 20,
      center: true,
      render: (_, index) => <p>{index + 1}</p>,
    },
    {
      title: "Profile",
      width: 60,
      center: true,
      render: (rowData) => (
        <React.Fragment>
          {rowData.group_cover !== null ? (
            <img
              alt="profile-chat"
              src={rowData.group_cover}
              height={24}
              width={24}
              style={{ borderRadius: "20px" }}
            />
          ) : (
            <DefaultImgContainer
              style={{
                backgroundColor: stringToColor(
                  `${rowData.full_name !== null ? rowData.full_name : "Blank"}`
                ),
              }}
            >
              <DefaultImg>
                {rowData.full_name.slice(0, 1).toUpperCase()}
              </DefaultImg>
            </DefaultImgContainer>
          )}
        </React.Fragment>
      ),
    },
    {
      title: "Nama Grup",
      key: "group_name",
    },
    {
      title: "Jenis Group",
      key: "category_name",
    },
    {
      title: "Anggota",
      render: (rowData) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <IconGroup />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              whiteSpace: "nowrap",
            }}
          >
            <p>Laki-laki : {rowData.total_male}</p>
            <p>Perempuan : {rowData.total_famale}</p>
            <p>Total : {rowData.total_member}</p>
          </div>
        </div>
      ),
      center: true,
    },
    {
      title: "Kota",
      render: (rowData) => (
        <div>
          <p>{rowData.city ? capFirstLetter(rowData.city) : "-"}</p>
        </div>
      ),
    },
    {
      title: "Tanggal Dibuat",
      render: (rowData) => (
        <p>{moment(rowData.create_at).format("DD MMM YYYY")}</p>
      ),
    },
    {
      title: "Status",
      center: true,
      width: 150,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {
            <div
              style={{
                border:
                  rowData.group_status === "1"
                    ? "1px solid #039C40"
                    : rowData.group_status === "2"
                    ? "1px solid #115ABE"
                    : rowData.group_status === "3"
                    ? "1px solid #C80707"
                    : "1px solid #C80707",
                backgroundColor:
                  rowData.group_status === "1"
                    ? "#AEF8AC"
                    : rowData.group_status === "2"
                    ? "rgba(181, 190, 233, 0.29)"
                    : "rgba(245, 150, 150, 0.2)",
                borderRadius: "30px",
                padding: "4px 20px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "16px",
                color:
                  rowData.group_status === "1"
                    ? "#039C40"
                    : rowData.group_status === "2"
                    ? "#115ABE"
                    : "#C80707",
              }}
            >
              {rowData.group_status === "1"
                ? "Aktif"
                : rowData.group_status === "2"
                ? "Menunggu"
                : rowData.group_status === "3"
                ? "Ditolak"
                : "Dinonaktifkan"}
            </div>
          }
        </div>
      ),
    },
    {
      title: "Postingan",
      render: (rowData) => <p>{rowData.total_post} Post</p>,
      center: true,
    },
    {
      title: "Aksi",
      width: 100,
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            borderRadius="5px"
            padding="0px 7px 0px 9px"
            onClick={() => {
              dispatch(setSelectGrup(rowData));
              actionHandler(rowData.group_id, rowData.group_status);
            }}
          >
            Detail
            <img src={eye} alt="eye" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  useEffect(() => {
    dispatch(getDasboardGroup());
  }, [dispatch]);

  const actionHandler = (grup_id, group_status) => {
    if (group_status === "1" || group_status === "4") {
      dispatch(getDetailGrup(grup_id));
    } else {
      dispatch(getRequestGrup(grup_id));
    }
    setHistory("page");
  };

  useEffect(() => {
    if (Object.keys(dashboardGroup).length !== 0) {
      const { Aktif, Menunggu, Tolak } = dashboardGroup.total_grup[0];
      const total = parseInt(Aktif) + parseInt(Menunggu) + parseInt(Tolak);
      const data = [
        (100 / total) * Aktif,
        (100 / total) * Menunggu,
        (100 / total) * Tolak,
      ];
      setPieChart([
        {
          ...initialPieChart[0],
          empty: total === 0,
          data: total === 0 ? [100] : data,
          backgroundColor: [
            total === 0 ? "#bbbaba" : "#115ABE",
            "#FFBF0B",
            "#FA3E3E",
          ],
        },
      ]);

      const mapDataSet = [
        {
          label: "Perusahaan",
          data: dashboardGroup.chart.map((item) => parseInt(item.Perusahaan)),
          backgroundColor: "#FFBF0B",
          pointStyle: "rectRounded",
        },
        {
          label: "Komunitas",
          data: dashboardGroup.chart.map((item) => parseInt(item.Komunitas)),
          backgroundColor: "#F86C6C",
          pointStyle: "rectRounded",
        },
        {
          label: "Serikat Pekerja",
          data: dashboardGroup.chart.map((item) =>
            parseInt(item["Serikat Pekerja"])
          ),
          backgroundColor: "#03B74B",
          pointStyle: "rectRounded",
        },
      ];
      setDataSet(mapDataSet);
    }
  }, [dashboardGroup]);

  return (
    <Container>
      {/* Title */}
      <Title title="Data Grup" />

      <RowWrapper>
        <ContentWrapper style={{ width: "70%" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p
                style={{
                  fontWeight: 400,
                  fontSize: "15px",
                  lineHeight: "18px",
                }}
              >
                Total Grup
              </p>
              <p
                style={{
                  fontWeight: 700,
                  fontSize: "20px",
                  lineHeight: "24px",
                }}
              >
                {dashboardGroup?.total_grup
                  ? dashboardGroup?.total_grup[0]?.total_grup
                  : 0}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "3px",
                backgroundColor: "#DEE5EF",
                boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1)",
                padding: "4px 6px",
                height: "fit-content",
                borderRadius: "3px",
                alignItems: "center",
              }}
            >
              <img
                alt="img-calendar"
                src={iconCalendar}
                width={18}
                height={18}
              />
              <p
                style={{
                  fontWeight: 400,
                  fontSize: "10px",
                  lineHeight: "12px",
                }}
              >
                {new Date().getFullYear()}
              </p>
            </div>
          </div>

          {/* Chart Bar */}
          <ChartBar datasets={datasets} />
        </ContentWrapper>

        {/* Chart Donat */}
        <ContentWrapper style={{ width: "30%" }}>
          <TitleBar>Jumlah Status Grup</TitleBar>
          <Chart
            data={pieChart}
            description={
              dashboardGroup?.total_grup
                ? `${dashboardGroup?.total_grup[0]?.total_grup} Grup`
                : "0 Grup"
            }
          />
        </ContentWrapper>
      </RowWrapper>

      {/* Table */}
      <RowWrapper>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "100%",
          }}
        >
          <Table
            headerContent={dataHeader}
            dataContent={dashboardGroup.list_grup}
          />
          <div style={{ display: "flex", justifyContent: "end" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "15px",
                lineHeight: "18px",
                color: "#115AAA",
                cursor: "pointer",
              }}
              onClick={() => dispatch(setActiveStep("all"))}
            >
              Lihat Semua
            </p>
          </div>
        </div>
      </RowWrapper>
    </Container>
  );
};

const initialPieChart = [
  {
    data: [0, 0, 0],
    backgroundColor: ["#bbbaba", "#FFBF0B", "#FA3E3E"],
    borderWidth: 0,
    label: [
      {
        title: "Aktif",
        color: "#115ABE",
      },
      {
        title: "Menunggu",
        color: "#FFBF0B",
      },
      {
        title: "Ditolak",
        color: "#FA3E3E",
      },
    ],
  },
];

const DefaultImgContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border-radius: 100%;
`;

const DefaultImg = styled("p")`
  color: white;
  text-decoration: none;
  font-size: 13px;
`;

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

const RowWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  width: "100%",
}));

const ContentWrapper = styled("div")(() => ({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1)",
  padding: "15px",
  borderRadius: "10px",
  height: "267px",
  gap: "15px",
  display: "flex",
  flexDirection: "column",
  whiteSpace: "nowrap",
  minWidth: "fit-content",
}));

const TitleBar = styled("p")(() => ({
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: "18px",
  letterSpacing: "0.01em",
  color: "#000000",
}));

export default DataGroup;
